module.exports = __webpack_public_path__ + "img/6.1b9db839.jpg";